import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/carl/Source/Repos/ThreadHound/pw.community.bot/app/(shopfront)/api-docs/react-swagger.tsx");
